import gsap from "gsap";

import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

document.querySelectorAll(".js-trust").forEach((section) => {
	const track = document.querySelector(".logo-track");
	if (!track) return;

	const totalWidth = track.scrollWidth / 2; // Half because of duplication
	const speed = 75; // px per second (adjust as needed)
	const duration = totalWidth / speed;

	gsap.to(track, {
		x: `-=${totalWidth}`,
		duration,
		ease: "none",
		repeat: -1,
		modifiers: {
			x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth),
		},
	});

	initOnScrollAnimation(section);
});
